export default __webpack_public_path__ + "static/media/popNotification.5b688e1e.mp3";